<template>
  <v-list dense>
    <div
      v-for="item in menu"
      :key="item.name"
    >
      <v-list-item
        link
        v-if="!verifyIfHasSubmenu(item)"
        @click="redirectMenu(item)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        no-action
        sub-group
        v-else
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(sub, i) in item.sub"
          :key="i"
          link
        >
          <v-list-item-title v-text="sub.name" @click="$router.push(sub.link)"/>
        </v-list-item>
      </v-list-group>
    </div>

  </v-list>
</template>

<script>
import { translations } from '@/lang/translations';

export default {
  name: 'MobileMenuList',
  computed: {
    menu() {
      return translations[this.$store.state.language].menu;
    },
  },
  methods: {
    verifyIfHasSubmenu(item) {
      if (item.sub) {
        return true;
      }
      return false;
    },
    redirectMenu(item) {
      if (!this.verifyIfHasSubmenu(item)) {
        this.$router.push(item.link);
      }
    },
  },
};
</script>

<style scoped>

</style>
